<script>
import { clientAdmin } from '@/utils/auth';
import axios from '@/utils/axios';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useCountryStore } from '@/stores/useCountryStore';
import { useStatesStore } from '@/stores/useStatesStore';

export default {
 inject: ['setLoading'], 
  data() {
   return {
    errors: {},
    title: "Settings",
    text: "Administration",
    text1: "Settings",
    editorConfig: {
      toolbar: {
        items: ['bold', 'italic']
      },
      // 🔧 RESIZEOBSERVER FIX
      resize_enabled: false, 
      resize_image: {
        resizeOptions: [
          { name: 'resize-original', label: 'Original', value: null }
        ]
      }
    },
    editor: ClassicEditor,
    states: [],
    countries: [],
    industries: [],
    summary: '',
    company_name: '',
    industry: null,
    email: '',
    alt_email: '',
    mobile: '',
    phone: '',
    gst: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    logo: null,
    website_url: '',
    signature: null,
    watermark: null,
    logo_preview: null,
    signature_preview: null,
    watermark_preview: null,
   };
 },

 mounted(){
  this.getCountries();
  this.getIndustries();

  //PREFILL VALUES
  this.logo_preview = this.clientAdmin?.company?.logo_url || null;
this.signature_preview = this.clientAdmin?.company?.signature_url || null;
this.watermark_preview = this.clientAdmin?.company?.watermark_url || null;
  this.company_name = this.clientAdmin?.company?.company_name || '';
  this.email = this.clientAdmin?.company?.email || '';
  this.mobile = this.clientAdmin?.company?.mobile || '';
  this.alt_email = this.clientAdmin?.company?.alt_email || '';
  this.phone = this.clientAdmin?.company?.phone || '';
  this.gst = this.clientAdmin?.company?.gst || '';
  this.address = this.clientAdmin?.company?.address || '';
  this.pincode = this.clientAdmin?.company?.pincode || '';
  this.city = this.clientAdmin?.company?.city || '';
  this.summary = this.clientAdmin?.company?.summary || '';
  this.website_url = this.clientAdmin?.company?.website_url || '';
 },

 methods: {
  
  async getIndustries(){
   this.errors = {};
   this.setLoading(true);
   try{
    const response = await axios.get('/industries');
    this.industries = response.data.data;
    this.industry = this.industries.find(i => i.id === this.clientAdmin?.company?.industry_id);
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  // async getCountries(){
  //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('/countries');
  //   this.countries = response.data.data;
  //   this.country = this.countries.find(c => c.name === this.clientAdmin?.company?.country);
  //   this.getStates(this.country?.id);
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  } 
  // },

  async getCountries(){
  const store = useCountryStore()
  this.countries = await store.loadCountries()
  this.country = this.countries.find(c => c.name === this.clientAdmin?.company?.country)
  this.getStates(this.country?.id)
},

  onCountrySelect(country){
   this.getStates(country?.id);
  },

  // async getStates(country_id){
  //  this.state = null;
  //  this.states = [];
  //   if(country_id){
  //   try{
  //    const response = await axios.get(`/states/${country_id}`);
  //    this.states = response.data.data;
  //    this.state = this.states.find(s => s.name === this.clientAdmin?.company?.state);
  //   }catch(error){
  //    this.$swalToast(error.message, 'error');
  //   }
  //  }  
  // },

  async getStates(country_id){
  this.state = null;
  this.states = [];
  if(country_id){
    const store = useStatesStore()
    this.states = await store.loadStates(country_id)
    this.state = this.states.find(s => s.name === this.clientAdmin?.company?.state)
  }
},

  handleLogoUpload(event){
   const file = event.target.files[0];
   this.logo = file;
   if(file){
    this.logo_preview = URL.createObjectURL(file);
   }else{
    this.logo_preview = this.$clientLogo(this.clientAdmin?.company?.logo, this.clientAdmin);
   }
  },

  handleSignatureUpload(event){
  const file = event.target.files[0];
  this.signature = file;
  if(file){
    this.signature_preview = URL.createObjectURL(file);
  }else{
    this.signature_preview = this.clientAdmin?.company?.signature_url || null;
  }
},

handleWatermarkUpload(event){
  const file = event.target.files[0];
  this.watermark = file;
  if(file){
    this.watermark_preview = URL.createObjectURL(file);
  }else{
    this.watermark_preview = this.clientAdmin?.company?.watermark_url || null;
  }
},

  async submitForm(){
   this.errors = {};
   this.setLoading(true);
   try{
    const formData = new FormData();
    formData.append('user_id', this.clientAdmin?.id);
    formData.append('industry_id', this.industry?.id);
    formData.append('company_name', this.company_name);
    formData.append('email', this.email);
    formData.append('mobile', this.mobile);
    formData.append('alt_email', this.alt_email);
    formData.append('phone', this.phone);
    formData.append('gst', this.gst);
    formData.append('address', this.address);
    formData.append('city', this.city);
    formData.append('state', this.state?.name);
    formData.append('country', this.country?.name);
    formData.append('pincode', this.pincode);
    formData.append('summary', this.summary);
    formData.append('website_url', this.website_url);
    
    if(this.logo){
     formData.append('logo', this.logo);
    }
    if(this.signature){
     formData.append('signature', this.signature);
    }
    if(this.watermark){
     formData.append('watermark', this.watermark);
    }

    const response = await axios.post('/users/company/update', formData, {
     headers: { 'Content-Type': 'multipart/form-data',},
    });
    const client_admin = response.data.data;
    localStorage.setItem('client_admin', JSON.stringify(client_admin));
    this.$swalToast(response.data.message);
   }catch(error){
    if(error.type == 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error');
    }    
   }finally{
    this.setLoading(false);
   }
  },

 },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="head-icons ms-2">
 
</div>
</div>
<!-- /Breadcrumb -->

<settings-tab></settings-tab>
<div class="row">
<general-sidebar></general-sidebar>
<div class="col-xl-9">
<div class="card">
<div class="card-body">
<div class="border-bottom mb-3 pb-3">
  <h4>Business Settings</h4>
</div>
<form @submit.prevent="submitForm" enctype="multipart/form-data">
  <div class="border-bottom mb-3">
    <div class="row">
      <div class="col-md-12">
        <div>
          <h6 class="mb-3">Basic Information</h6>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Company Name</label>
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" v-model="company_name" />
            <div class="text-danger small mt-1" v-if="errors.company_name">{{errors.company_name[0]}}</div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Industry</label>
          </div>
          <div class="col-md-8">
            <vue-select :options="industries" label="name" v-model="industry" />  
            <div class="text-danger small mt-1" v-if="errors.industry">{{errors.industry[0]}}</div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Email Address</label>
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" v-model="email" />
            <div class="text-danger small mt-1" v-if="errors.email">{{errors.email[0]}}</div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Alternate Email</label>
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" v-model="alt_email" />
            <div class="text-danger small mt-1" v-if="errors.alt_email">{{errors.alt_email[0]}}</div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Mobile</label>
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" v-model="mobile" />
            <div class="text-danger small mt-1" v-if="errors.mobile">{{errors.mobile[0]}}</div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Phone No</label>
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" v-model="phone" />
            <div class="text-danger small mt-1" v-if="errors.phone">{{errors.phone[0]}}</div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="row align-items-center mb-3">
          <div class="col-md-3">
            <label class="form-label mb-md-0">GST</label>
          </div>
          <div class="col-md-9">
            <input type="text" class="form-control" v-model="gst" />
            <div class="text-danger small mt-1" v-if="errors.gst">{{errors.gst[0]}}</div>
          </div>
        </div>
      </div>
      
    </div>
  </div>

  <div class="border-bottom mb-3">
  <h6 class="mb-3">Company Images</h6>
  <div class="row">
  
  <div class="col-md-6">
  <div class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
  <div class="d-flex align-items-center justify-content-center avatar avatar-xxl bg-white rounded border border-dashed me-2 flex-shrink-0 text-dark frames px-2">
   <img :src="logo_preview" class="img-fluid" alt="logo" width="50" />
    </div>
   <div class="profile-upload">
    <div class="mb-2">
      <h6 class="mb-1">Logo</h6>
      <p class="fs-12">Recommended image size is 250px x 250px</p>
    </div>
    <div class="profile-uploader d-flex align-items-center">
      <div class="drag-upload-btn btn btn-sm btn-primary me-2">
        Change
      <input type="file" class="form-control image-sign" @change="handleLogoUpload"/>
      </div>
    </div>
    <div v-if="errors.logo" class="text-danger small mt-1">{{ errors.logo[0] }}</div>
    </div>
   </div>
   </div>

  <div class="col-md-6">
  <div class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
  <div class="d-flex align-items-center justify-content-center avatar avatar-xxl bg-white rounded border border-dashed me-2 flex-shrink-0 text-dark frames px-2">
   <img :src="signature_preview" class="img-fluid" alt="signature" v-if="signature_preview" />
    </div>
   <div class="profile-upload">
    <div class="mb-2">
      <h6 class="mb-1">Signature</h6>
      <p class="fs-12">Recommended image size is 250px x 250px</p>
    </div>
    <div class="profile-uploader d-flex align-items-center">
      <div class="drag-upload-btn btn btn-sm btn-primary me-2">
        Change
      <input type="file" class="form-control image-sign" @change="handleSignatureUpload"/>
      </div>
      <div v-if="errors.signature" class="text-danger small mt-1">{{ errors.signature[0] }}</div>
    </div>
    </div>
   </div>
   </div>

  <div class="col-md-6">
  <div class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
  <div class="d-flex align-items-center justify-content-center avatar avatar-xxl bg-white rounded border border-dashed me-2 flex-shrink-0 text-dark frames px-2">
   <img :src="watermark_preview" class="img-fluid" alt="watermark" v-if="watermark_preview" />
    </div>
   <div class="profile-upload">
    <div class="mb-2">
      <h6 class="mb-1">Watermark</h6>
      <p class="fs-12">Recommended image size is 500px x 500px</p>
    </div>
    <div class="profile-uploader d-flex align-items-center">
      <div class="drag-upload-btn btn btn-sm btn-primary me-2">
        Change
      <input type="file" class="form-control image-sign" @change="handleWatermarkUpload"/>
      </div>
      <div v-if="errors.watermark" class="text-danger small mt-1">{{ errors.watermark[0] }}</div>
    </div>
    </div>
   </div>
   </div>

  </div>
  </div>

  <div class="border-bottom mb-3">
    <h6 class="mb-3">Address Information</h6>
    <div class="row">
      <div class="col-md-12">
        <div class="row align-items-center mb-3">
          <div class="col-md-2">
            <label class="form-label mb-md-0">Address</label>
          </div>
          <div class="col-md-10">
            <input type="text" class="form-control" v-model="address" />
            <div class="text-danger small mt-1" v-if="errors.address">{{ errors.address[0] }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Country</label>
          </div>
          <div class="col-md-8">
            <div>
              <vue-select :options="countries" label="name" v-model="country" @update:modelValue="onCountrySelect" />
              <div v-if="errors.country" class="text-danger small mt-1">{{ errors.country[0] }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">State</label>
          </div>
          <div class="col-md-8">
            <div>
              <vue-select :options="states" label="name" v-model="state" />
              <div v-if="errors.state" class="text-danger small mt-1">{{ errors.state[0] }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">City</label>
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" v-model="city" />
            <div class="text-danger small mt-1" v-if="errors.city">{{ errors.city[0] }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Postal Code</label>
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" v-model="pincode" />
            <div class="text-danger small mt-1" v-if="errors.pincode">{{ errors.pincode[0] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

    <div class="border-bottom mb-3">
    <div class="row">
      <div class="col-md-12">
        <div class="row align-items-center mb-3">
          <div class="col-md-2">
            <label class="form-label mb-md-0">Website URL</label>
          </div>
          <div class="col-md-10">
            <input type="text" class="form-control" v-model="website_url" />
            <div class="text-danger small mt-1" v-if="errors.website_url">{{ errors.website_url[0] }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row align-items-center mb-3">
          <div class="col-md-2">
            <label class="form-label mb-md-0">About Company</label>
          </div>
          <div class="col-md-10">
            <ckeditor :editor="editor" v-model="summary" :config="editorConfig"></ckeditor>
            <div class="text-danger small mt-1" v-if="errors.summary">{{ errors.summary[0] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-end">
   <!-- <button type="button" class="btn btn-outline-light border me-3"> Cancel </button> -->
   <button type="submit" class="btn btn-primary">Save</button>
  </div>
</form>
</div>
</div>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->
</template>
